<img class="img-fluid" [src]="finalUrl">
